export type PickerColors = { color: string, className: string }

export const ColorPickerColors: Array<PickerColors> = [
  { color: '#EECF6D', className: 'yellow' },
  { color: '#8B6220', className: 'brown' },
  { color: '#048A81', className: 'cyan' },
  { color: '#FFB7C3', className: 'pink' },
  { color: '#171d1c', className: 'black' },
  { color: '#b1a7a6', className: 'gray' }
]
